<template>
  <action-button
    variant="text"
    size="small"
    extraClass="py-1 pointerEventAuto h-36"
    :click="copyToClip"
  >
    <img
      src="@/assets/images/icons/copy-clipboard.svg"
      alt="copy"
      width="16"
      class="mr-2"
    />
    <div class="d-none d-md-block w-max-content">
      {{ $t('invoices.upload.copy_text') }}
    </div>
  </action-button>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'

export default {
  props: ['copyText'],
  components: { ActionButton },
  methods: {
    copyToClip(e) {
      e.stopPropagation()
      const val = this.copyText
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(val)
          .then(() => {
            // Successful copy
            this.$notify({
              title: 'Copied to clipboard!',
              type: 'success'
            })
          })
          .catch((err) => {
            // Clipboard write failed
            console.error('Failed to copy text:', err)
            this.$notify({
              title: 'Failed to copy to clipboard!',
              type: 'error'
            })
          })
      } else {
        const textArea = document.createElement('textarea')
        textArea.value = val

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = 'absolute'
        textArea.style.left = '-999999px'

        document.body.prepend(textArea)
        textArea.select()

        try {
          document.execCommand('copy')
          this.$notify({
            title: 'Copied to clipboard!',
            type: 'success'
          })
        } catch (error) {
          console.error(error)
          this.$notify({
            title: 'Failed to copy to clipboard!',
            type: 'error'
          })
        } finally {
          textArea.remove()
        }
      }
    }
  }
}
</script>
<style lang="scss">
.pointerEventAuto {
  pointer-events: auto;
}
.h-36 {
  height: 36px !important;
}
</style>
